<template>
  <div class="history-result">
    <div class="history-title">ຜົນການອອກເລກລາງວັນ</div>
    <div class="history-content">
      <table>
        <tbody>
          <tr>
            <td><strong>ງວດວັນທີ່</strong></td>
            <td width="18%"><strong>ເລກ 5 ໂຕ</strong></td>
            <td width="18%"><strong>ເລກ 3 ໂຕ</strong></td>
            <td width="18%"><strong>ເລກ 2 ໂຕເທິ່ງ</strong></td>
            <td width="18%"><strong>ເລກ 2 ໂຕລຸ່ມ</strong></td>
          </tr>
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.lotto_date | date }}</td>
            <td>{{ item.results | result('digit5') }}</td>
            <td>{{ item.results | result('digit3') }}</td>
            <td>{{ item.results | result('digit2_top') }}</td>
            <td>{{ item.results | result('digit2_bottom') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

export default {
  name: 'HistoryResults',
  data() {
    return {
      data: []
    }
  },
  computed: {
    items() {
      return this.data
    }
  },
  methods: {
    getResults() {
      LottoService.getHistories().then((response)=>{
        if(response.status === 'success') {
          this.data = response.data
        }
      })
    }
  },
  created() {
    this.getResults()
  },
  filters: {
    date(param) {
      return moment(param).format("LL")
    },
    result(param, digit) {
      if(param) {
        let results = param
        return results[digit]
      }else {
        return '-'
      }
    }
  },
}

</script>
<style lang="scss" scoped>
.history-result {
  margin-top: 15px;
  min-height: 150px;
  color: #000;
  background-color: #fff;
  padding-bottom: 20px;

  .history-title {
    text-align: center;
    font-size: 26px;
    margin-bottom: 15px;
    border:2px solid #011B5C;
  }
  .history-content {
    padding: 0;
    table {
      width: 100%;
      max-width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      background-color: #FFF;

      thead {
        tr {
          th {
            text-align: center;
            font-size: 26px;
            /*background: url('../../assets/theme/bg4.png') no-repeat center top;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;*/
          }
        }
      }

      tbody {
        tr {
          td {
            text-align: center;
            border: 1px solid #999;
            padding: 5px;
            font-size: 16px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {

}
</style>
